import { User } from "@/modules/user/types/user.type";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface UserState {
  userMe: User | null;
}

const initialUserState = {
  userMe: null,
} as UserState;

const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    setUserMe(state, action: PayloadAction<User>) {
      state.userMe = action.payload;
    },

  },
});

export const userAction = userSlice.actions;
export const userReducer = userSlice.reducer;
